module.exports = __webpack_public_path__ + "img/light_0_1.ad232207.png";